import { DateZone, OptionType } from '@oai-frontend-monorepo/types';
import { DateTime } from 'luxon';

export const parseOptionSymbol = (optionSymbol: string) => {
  const regex = /^([A-Z]+)(\d{2})(\d{2})(\d{2})([CP])(\d{5})(\d{3})$/;
  const match = optionSymbol.match(regex);

  if (optionSymbol.length < 7) {
    return {
      underlyingSymbol: optionSymbol,
    };
  }

  if (!match) {
    return undefined;
  }

  const underlyingSymbol = match[1];
  const year = match[2];
  const month = match[3];
  const day = match[4];
  const optionType = match[5] === 'C' ? OptionType.CALL : OptionType.PUT;

  // The strike price includes the first 5 digits and the last 3 digits are fractional
  const strikeWhole = parseInt(match[6], 10);
  const strikeFractional = parseInt(match[7], 10);
  const strike = strikeWhole + strikeFractional / 1000;

  const expirationDate = `${year}${month}${day}`;

  if (!underlyingSymbol || !expirationDate || !optionType || !strike) {
    return undefined;
  }

  return {
    underlyingSymbol,
    expiration: expirationDate,
    expirationDate: DateTime.fromFormat(expirationDate, 'yyMMdd', {
      zone: DateZone.New_York,
    }).set({ hour: 16 }),
    optionType,
    strike,
  };
};
